export default __webpack_public_path__ + "static/media/nossas_unidades_5.47111131.webp";